// extracted by mini-css-extract-plugin
module.exports = {"container":"tags_container__1Lxgr","search":"tags_search__gdTLi","result":"tags_result__rVXTL","isSearch":"tags_isSearch__2oPr8"};